export enum DATE_GROUPS {
  YEAR = 'year',
  NUMERIC_MONTH = 'numericMonth',
  MONTH_NAME_FULL = 'fullMonth',
  MONTH_NAME_SHORT = 'shortMonth',
  DAY = 'day',
}
/**
 * Date regex components with predefined capturing groups.
 *
 * Capturing groups `()` are defined **here** to ensure consistency across DATE_FORMATS.
 * This prevents duplicate wrapping of groups inside DATE_FORMATS, making regex matches predictable.
 * Keeping all parts centralized allows easy maintenance without modifying every format in DATE_FORMATS.
 */

export const REGEX_PARTS_DATE = {
  MM: `(?<${DATE_GROUPS.NUMERIC_MONTH}>\\d{1,2})`, // Accept 1 or 2 digits — allow parser to validate range
  DD: `(?<${DATE_GROUPS.DAY}>\\d{1,2})`, // Accept 1 or 2 digits — allow parser to validate range
  YYYY: `(?<${DATE_GROUPS.YEAR}>\\d{4})`, // Allows any four-digit year (0000-9999)
  MMM: `(?<${DATE_GROUPS.MONTH_NAME_SHORT}>[a-zA-Z]{3})`, // 3-letter month abbreviation ("Jan", "Feb", etc.)
  MMMM: `(?<${DATE_GROUPS.MONTH_NAME_FULL}>[a-zA-Z]{3,9})`, // Full month names ("January", "February", etc.)
  SEP: '[.\\-/\\s,]', // Supports ".", "/", "-", spaces, AND commas
};
